import "./AnimationPage.scss"
import SidebarComponent from "../../components/SidebarComponent/SidebarComponent";
import FooterComponent from "../../components/FooterComponent/FooterComponent";
import bloomAnimation from "../../resources/animations/bloomAnimation.mov"
import blinkAnimation from "../../resources/animations/blinkAnimation.mp4"
import silhouettesAnimation from "../../resources/animations/silhouettesAnimation.mp4"
import flameAnimation from "../../resources/animations/flameAnimation.mp4"
import closeButton from "../../resources/images/buttonImages/close.png"
import {useState} from "react";
import DetailVideoViewComponent from "../../components/DetailVideoViewComponent/DetailVideoViewComponent";

const AnimationPage = (colourClassName) => {
  const [showDetailVideoView, setShowDetailVideoView] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);
  
  const openDetailVideoView = (video) => {
    setShowDetailVideoView(true);
    setSelectedVideo(video);
  };

  const closeDetailVideoView = () => {
    setShowDetailVideoView(false);
  };

  return (
    <div className="animationPage">
    <div className="animationContainer">
      <SidebarComponent colourClassName={colourClassName}/>
      <div className="displayAnimations">
        <div className="animationGrid">
          <video autoPlay loop className="full-height" onClick={() => openDetailVideoView(bloomAnimation)}>
            <source src={bloomAnimation} type="video/mp4"/>
          </video>
          <video autoPlay loop className="half-height" onClick={() => openDetailVideoView(blinkAnimation)}>
            <source src={blinkAnimation} type="video/mp4"/>
          </video>
          <video autoPlay loop className="half-height" onClick={() => openDetailVideoView(silhouettesAnimation)}>
            <source src={silhouettesAnimation} type="video/mp4"/>
          </video>
          <video autoPlay loop className="full-height" onClick={() => openDetailVideoView(flameAnimation)}>
            <source src={flameAnimation} type="video/mp4"/>
          </video>
        </div>
        {showDetailVideoView && (
            <div>
              <DetailVideoViewComponent video={selectedVideo}/>
              <button onClick={closeDetailVideoView} className="closeButton"><img src={closeButton} alt=""/></button>
            </div>
          )}
        <FooterComponent className="animationFooter" colourClassName=""/>
      </div>
    </div>
  </div>
  );
};

export default AnimationPage;
